<template>
  <div v-if="topCategory">
    <SideCategory
      v-for="subCategory in topCategory.children"
      :key="subCategory.slug"
      :category="subCategory"
    />
  </div>
</template>

<script lang="ts">


export default defineComponent({
  name: 'SideCategories',

  setup() {

    const { categories } = useCategories();
    const topCategory = computed(() => {

      return categories.value?.[0];
    
    });

    return {
      topCategory,
    };
  
  },
});

</script>
